import React from 'react';
import ReactDOM from 'react-dom';
import styled from 'styled-components';
import SurveyToast from './components/SurveyToast';
import {
  warning,
  ErrorCodes,
} from './components/SurveyToast/businessLogics/warning';

const el = document.getElementById('rexSurveyRoot');
if (!el) {
  warning(ErrorCodes.ERR_NO_ROOT_ELEMENT)();
}
if (!window.rexSurveyConfig) {
  warning(ErrorCodes.ERR_NO_CONFIG)();
} else {
  const config = window.rexSurveyConfig;
  if (!config.surveyId) {
    warning(ErrorCodes.ERR_NO_SURVEY_ID)();
  }
}

if (el && window.rexSurveyConfig) {
  // postion & z-index for c5 z-index issue #UXDCOEIPS-86
  // text-align: center on desktop version #UXDCOEIPS-40
  const SurveyContainer = styled.aside`
    position: relative;
    z-index: 9003;
    text-align: left;
  `;

  ReactDOM.render(
    <SurveyContainer>
      <SurveyToast config={window.rexSurveyConfig} />
    </SurveyContainer>,
    el
  );
}



// WEBPACK FOOTER //
// ./src/index.js